export const TABLE_MANAGEMENT_SUBSCRIPTION_PAGE_REQUEST =
  'TABLE_MANAGEMENT_SUBSCRIPTION_PAGE_REQUEST';
export const TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS =
  'TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS';
export const TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE =
  'TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SUBSCRIPTION_STATUS =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SUBSCRIPTION_STATUS';
export const TABLE_MANAGEMENT_SUBSCRIPTION_FINISH_LOADING_PAGE =
  'TABLE_MANAGEMENT_SUBSCRIPTION_FINISH_LOADING_PAGE';
export const TABLE_MANAGEMENT_SUBSCRIPTION_END_TUTORIAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_END_TUTORIAL';
export const TABLE_MANAGEMENT_SUBSCRIPTION_VERIFY_BILLING =
  'TABLE_MANAGEMENT_SUBSCRIPTION_VERIFY_BILLING';
export const TABLE_MANAGEMENT_SUBSCRIPTION_START_TRIAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_START_TRIAL';

export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_OUTLETS =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_OUTLETS';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SET_BUTTON_MESSAGE =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SET_BUTTON_MESSAGE';

export const TABLE_MANAGEMENT_SUBSCRIPTION_GET_BILLINGS =
  'TABLE_MANAGEMENT_SUBSCRIPTION_GET_BILLINGS';
export const TABLE_MANAGEMENT_SUBSCRIPTION_GET_OUTLETS =
  'TABLE_MANAGEMENT_SUBSCRIPTION_GET_OUTLETS';

export const TABLE_MANAGEMENT_SUBSCRIPTION_ENABLE_PAY_BUTTON =
  'TABLE_MANAGEMENT_SUBSCRIPTION_ENABLE_PAY_BUTTON';
export const TABLE_MANAGEMENT_SUBSCRIPTION_DISABLE_PAY_BUTTON =
  'TABLE_MANAGEMENT_SUBSCRIPTION_DISABLE_PAY_BUTTON';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL';
export const TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL';
export const TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';
export const TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL =
  'TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';
